import QuantityType from '@components/UI-Components/QuantityType/components/QuantityType'
import { VIPClientType } from '@modules/common/models/enums/VIPClientType'
import { getEnumValue } from '@utils/get-enum-value'
import OrderTopBarBSGAndClient from '../components/OrderTopBarBSGAndClient'
import OrderTopbarKPITotals from '../components/OrderTopbarKPITotals'
import OrderTopbarOTBTotals from '../components/OrderTopbarOTBTotals'
import EnhancedOrderTopbarKPITotals from '../components/EnhancedOrderTopbarKPITotals/EnhancedOrderTopbarKPITotals'
import EnhancedOrderTopbarOTBTotals from '../components/EnhancedOrderTopbarOTBTotals/EnhancedOrderTopbarOTBTotals'

export const leftIcons = [
  {
    name: 'bsgAndClient',
    isCustomElement: true,
    customElement: OrderTopBarBSGAndClient,
    showIcon: true
  }
]

export const rightIcons = ({ clientType, quantityTypeProps }, isEnhancedViewEnabled?) => {
  return [
    {
      name: 'draftOrSize',
      isCustomElement: true,
      customElement: QuantityType,
      showIcon: true,
      customElementProps: quantityTypeProps
    },
    {
      name: 'kpiTotals',
      isCustomElement: true,
      customElement: isEnhancedViewEnabled
        ? EnhancedOrderTopbarKPITotals
        : OrderTopbarKPITotals,
      showIcon: clientType === getEnumValue(VIPClientType.External)
    },
    {
      name: 'retailOTB',
      isCustomElement: true,
      customElement: isEnhancedViewEnabled
        ? EnhancedOrderTopbarOTBTotals
        : OrderTopbarOTBTotals,
      showIcon: clientType === getEnumValue(VIPClientType.Internal)
    }
  ]
}
